"use client";

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import { AppDispatch } from "@/app/store";
import { fetchCompanyProfileAction } from "../../slices/companyProfileSlice";
import { MembershipSkuSection } from "@/modules/hub/features/MembershipSkuManagement/components/MembershipSkuSection/MembershipSkuSection";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const QuickBooksSettings: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { companyProfile } = useSelector(
    (state: RootState) => state.companyProfile,
  );
  const { userAppSettings } = useSelector(
    (state: RootState) => state.userAppSettings,
  );

  useEffect(() => {
    dispatch(fetchCompanyProfileAction());
  }, [dispatch]);

  if (!companyProfile) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>QuickBooks Online Integration</CardTitle>
          <CardDescription>Loading company profile...</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>QuickBooks Online Integration</CardTitle>
        <CardDescription>
          Configure membership SKUs for QuickBooks Online integration.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <MembershipSkuSection
          companyId={userAppSettings?.companyId ?? 0}
          companyUuid={companyProfile.uuid}
          currentTenant={userAppSettings?.intacctId}
        />
      </CardContent>
    </Card>
  );
};

export default QuickBooksSettings;
